import React, { useEffect, useState } from "react";
import { MessageCircle, CalendarCheck } from "lucide-react";
import { buildWhatsAppGenericUrl } from "../lib/whatsapp";

export const FloatingWhatsApp = () => (
  <a
    href={buildWhatsAppGenericUrl()}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-24 right-4 sm:bottom-6 sm:right-6 z-40 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_12px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform pulse-ring"
  >
    <MessageCircle className="w-7 h-7" strokeWidth={2} />
  </a>
);

export const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`sm:hidden fixed bottom-0 left-0 right-0 z-30 p-3 bg-white/95 backdrop-blur-xl border-t border-slate-100 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <a
        href="#booking"
        onClick={(e) => {
          e.preventDefault();
          document
            .querySelector("#booking")
            ?.scrollIntoView({ behavior: "smooth" });
        }}
        className="flex items-center justify-center gap-2 w-full h-12 rounded-full bg-brand-500 hover:bg-brand-600 text-white font-semibold shadow-md shadow-brand-500/30"
      >
        <CalendarCheck className="w-5 h-5" />
        Book Appointment
      </a>
    </div>
  );
};
